'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../../src/styles/external.scss');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _searchResult = require('./search-result');

var _searchResult2 = _interopRequireDefault(_searchResult);

var _pagination = require('./pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _utils = require('../utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//flow
var APPOINTMENTS = 'appointments';
var THROTTLE = 400;

var mobileScreenWidth = 768;

var SearchResults = function SearchResults(props) {
	return _react2.default.createElement(
		'div',
		{ id: _style2.default.SearchResults, className: 'row no-gutter' },
		!!props.selectedKeyword.length && window.innerWidth <= mobileScreenWidth && _react2.default.createElement(
			'p',
			{ className: '' + _style2.default.totalCount },
			'Found ',
			props.totalResults,
			' result',
			props.totalResults === 1 ? '' : 's',
			'.'
		),
		props.results.map(function (result, index) {
			return _react2.default.createElement(_searchResult2.default, (0, _extends3.default)({
				key: index
			}, result, {
				onHover: props.onHover ? (0, _throttle3.default)(function () {
					return props.onHover(result.id);
				}, THROTTLE) : null,
				selectedKeyword: props.selectedKeyword,
				bookingType: props.bookingType,
				searchType: props.searchType,
				specialtyIcon: (0, _utils.getSpecialtyIconUri)(props.specialtiesListing, result.specialty),
				selectedHospitalListId: props.selectedHospitalListId
			}));
		}),
		_react2.default.createElement(
			'div',
			{ className: 'text-center' },
			_react2.default.createElement(_pagination2.default, props)
		)
	);
};

SearchResults.propTypes = {
	results: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
	onHover: require('react').PropTypes.func,
	lastPage: require('react').PropTypes.any,
	selectedPage: require('react').PropTypes.any,
	onPageClicked: require('react').PropTypes.func,
	searchType: require('react').PropTypes.any,
	selectedKeyword: require('react').PropTypes.any,
	bookingType: require('react').PropTypes.any,
	specialtiesListing: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
	totalResults: require('react').PropTypes.number.isRequired,
	selectedHospitalListId: require('react').PropTypes.number
};
SearchResults.defaultProps = {
	results: [],
	onHover: function onHover() {},
	onPageClicked: function onPageClicked() {},
	lastPage: 0,
	searchType: APPOINTMENTS
};

SearchResults.displayName = 'SearchResults';

exports.default = SearchResults;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/search-results.js